import { useTableSettingsSelectors } from './use-table-settings-store'

export const useTableSettings = () => {
  const { hiddenColumns, setHiddenColumns } = useTableSettingsSelectors()
  return { hiddenColumns, setHiddenColumns }
}
